export class MileageFactor {
  id: number;
  validFrom: string = this.getFirstDayOfYear();
  validTo: string = this.getLastDayOfYear();
  baseRate: number;
  averageKms: number;
  deviationUpperLimit: number;
  deviationLowerLimit: number;
  upperLimitFactor: number;
  lowerLimitFactor: number;
  applyDealerBonus: boolean;
  minimumFee: number;
  
  getFirstDayOfYear() {
    let m = new Date(new Date().getFullYear(), 0, 1);
    return m.getFullYear() + '-' + m.getMonth() + 1 + '-' + this.addZero(m.getDate());
  }

  getLastDayOfYear() {
    let m = new Date(new Date().getFullYear(), 11, 31);
    return m.getFullYear() + '-' + (Number(m.getMonth()) + 1) + '-' + m.getDate();
  }

  addZero(n :number) {
    if (n < 10) {
      return '0' + n;
    } else {
      return n;
    }
  }
}
